__turbopack_context__.v({
  "backIcon": "CapacityConflictModalHeader-module-scss-module__EbdlVa__backIcon",
  "closeIcon": "CapacityConflictModalHeader-module-scss-module__EbdlVa__closeIcon",
  "cornerButton": "CapacityConflictModalHeader-module-scss-module__EbdlVa__cornerButton",
  "cornerButtonLeft": "CapacityConflictModalHeader-module-scss-module__EbdlVa__cornerButtonLeft",
  "cornerButtonRight": "CapacityConflictModalHeader-module-scss-module__EbdlVa__cornerButtonRight",
  "header": "CapacityConflictModalHeader-module-scss-module__EbdlVa__header",
  "headerCol": "CapacityConflictModalHeader-module-scss-module__EbdlVa__headerCol",
  "illustration": "CapacityConflictModalHeader-module-scss-module__EbdlVa__illustration",
  "title": "CapacityConflictModalHeader-module-scss-module__EbdlVa__title",
});
